import { useMemo } from "react"

import { parseSipHeaders } from "@/utils/simulation/realtimeFieldValidation"

/**
 * Memoizes the parsed object form of a JSON-string of custom SIP headers for
 * the inbound-voice field groups' JSON editor. Invalid/empty/non-object input
 * resolves to an empty object so the editor always receives a valid value.
 */
export function useSipHeadersJson(
  customSipHeaders: string | undefined,
): Record<string, unknown> {
  return useMemo(() => parseSipHeaders(customSipHeaders), [customSipHeaders])
}
